import { BubbleType, BubbleColor, ICore, Bubble, IBubbleHandler } from '../types';
import { IGameData } from 'js/bubbleCore/types';
import { putBubbleToGrid } from '../behavior/putBubbleToGrid';
import { getMatchingBubbles } from '../behavior/getMatchingBubbles';
import { popOutBubble } from '../behavior/popOutBubble';
import {
  IEvent,
  createUnsuccessfulMoveEvent,
  createSuccessfulMoveEvent,
} from 'js/bubbleCore/events';
import { BubbleGameBoard } from 'js/bubbleCore/BubbleGameBoard';

export interface IRegularCore extends ICore {
  type: BubbleType.Regular;
  color: BubbleColor;
};

export type BubbleRegular = Bubble<BubbleType.Regular>;

export const handler: IBubbleHandler<BubbleType.Regular> = {
  onShootedBubbleGridBubbleCollision,
  isMatching,
};

function onShootedBubbleGridBubbleCollision(
  board: BubbleGameBoard,
  bubble: BubbleRegular,
  colliders: Bubble[],
): void {
  const data = board.getData();
  const grid = data.grid;
  const events = board.getEventsQueue();

  try {
    putBubbleToGrid(data, bubble, colliders, events);
  } catch (e) {
    // failed to put in space, move to popout group
    console.warn(e);
    return;
  }

  const matching = getMatchingBubbles(data.grid, bubble);

  if (matching.length >= 3) {
    events.push(createSuccessfulMoveEvent(matching));
    matching.forEach((bubble) => {
      popOutBubble(board, bubble);
    });
  } else {
    events.push(createUnsuccessfulMoveEvent(bubble));
  }
}

function isMatching(bubble: BubbleRegular, otherBubble: Bubble): boolean {
  return otherBubble.core.color === bubble.core.color;
}
